// extracted by extract-css-chunks-webpack-plugin
module.exports = {"qr_box":"qr_box-1n_2SIw3"};